"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupTypes = void 0;
exports.groupTypes = {
    applications: 'applications',
    caseStudy: 'case-study',
    product: 'product',
    solutions: 'solutions',
    articles: 'articles',
    events: 'events',
    pastEvents: 'past-events',
    news: 'news',
    recommendedCourses: 'recommended-courses',
};
